import { render, staticRenderFns } from "./pagina.vue?vue&type=template&id=12608f50"
import script from "./pagina.vue?vue&type=script&lang=js"
export * from "./pagina.vue?vue&type=script&lang=js"
import style0 from "./pagina.vue?vue&type=style&index=0&id=12608f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports